export const THEME_OPENING_EXPERIENCES = {
  pearl_rose: {
    label: 'Gift Box Letter',
    variant: 'gift-letter',
    title: 'A Letter Wrapped in Love',
    subtitle: 'A soft gift box opens, then a personal letter rises from the glow.',
    material: 'Blush ribbon, rose paper, soft gold seal',
    action: 'Open the box',
    openedAction: 'Read the first layer',
    steps: ['Box', 'Letter', 'Memory'],
    colors: {
      bg: '#F8F1ED',
      surface: '#FFFDF9',
      accent: '#B84A5C',
      accent2: '#C99A63',
      ink: '#271D1D',
      muted: '#766762',
    },
  },
  wedding_favor: {
    label: 'Champagne Favor',
    variant: 'ribbon-card',
    title: 'A Favor From Our Day',
    subtitle: 'A champagne ribbon loosens, then a foil thank-you card opens into the wedding keepsake.',
    material: 'Ivory card, champagne foil, sage ribbon',
    action: 'Untie the ribbon',
    openedAction: 'Enter the favor',
    steps: ['Ribbon', 'Thank You', 'Blessing'],
    colors: {
      bg: '#F6F0E6',
      surface: '#FFFDF8',
      accent: '#C8A46A',
      accent2: '#7E8F7A',
      ink: '#211B1D',
      muted: '#6F6561',
    },
  },
  editorial_romance: {
    label: 'Private Envelope',
    variant: 'film-envelope',
    title: 'A Little Film of Us',
    subtitle: 'A black envelope opens, then a strip of private moments rolls into view.',
    material: 'Velvet black, deep berry, champagne light',
    action: 'Open the envelope',
    openedAction: 'Play the memory',
    steps: ['Envelope', 'Film', 'Voice'],
    colors: {
      bg: '#24191D',
      surface: '#FFF7F4',
      accent: '#8F2438',
      accent2: '#EAD0A0',
      ink: '#FFF7F4',
      muted: 'rgba(255, 247, 244, 0.72)',
    },
  },
  soft_family: {
    label: 'Little Milestone',
    variant: 'baby-album',
    title: 'A Tiny Book of Firsts',
    subtitle: 'A small album flips open and growth cards pop out like soft milestone notes.',
    material: 'Mint album, sky blue photo cards, butter yellow tabs',
    action: 'Open the album',
    openedAction: 'See the first chapter',
    steps: ['Album', 'Milestone', 'Wish'],
    colors: {
      bg: '#E6F4EF',
      surface: '#FFFFFB',
      accent: '#7BA7A0',
      accent2: '#F2D76F',
      ink: '#27313A',
      muted: '#66736F',
    },
  },
  quiet_keepsake: {
    label: 'Memory Archive',
    variant: 'memory-box',
    title: 'A Gentle Place to Remember',
    subtitle: 'A pearl memory box opens, and a soft-light album rises quietly from inside.',
    material: 'Pearl gray, eucalyptus, white daylight',
    action: 'Open the memory box',
    openedAction: 'Enter softly',
    steps: ['Archive', 'Voice', 'Timeline'],
    colors: {
      bg: '#F6F4EF',
      surface: '#FFFEFA',
      accent: '#6F8190',
      accent2: '#7BA7A0',
      ink: '#2F3230',
      muted: '#72756F',
    },
  },
  friends_graduation: {
    label: 'Polaroid Map',
    variant: 'polaroid-map',
    title: 'The Map of Us',
    subtitle: 'A Polaroid camera opens, a photo slides out, and the memory map unfolds below it.',
    material: 'Terracotta, denim, cream paper',
    action: 'Snap the memory',
    openedAction: 'Follow the map',
    steps: ['Booth', 'Map', 'Museum'],
    colors: {
      bg: '#F8EFD9',
      surface: '#FFF8EA',
      accent: '#BD583B',
      accent2: '#23476D',
      ink: '#23282B',
      muted: '#6E6E68',
    },
  },
};

export const getThemeOpeningConfig = (themeId) => (
  THEME_OPENING_EXPERIENCES[themeId] || null
);
